/**
 * Adónde manda el kiosko a una tele (dispositivo 'panel'): la pizarra del backoffice
 * que diga display_config.layout. Sin layout → la táctil (las teles de la oficina lo son).
 * Lógica pura, sin DOM, para poder probarla con node --test.
 */

export const PANEL_LAYOUTS = ['interactivo', 'clasico'];
export const DEFAULT_PANEL_LAYOUT = 'interactivo';

/** Layout efectivo: el guardado si es válido, si no el de por defecto. */
export function resolvePanelLayout(layout) {
  return PANEL_LAYOUTS.includes(layout) ? layout : DEFAULT_PANEL_LAYOUT;
}

/**
 * URL del tablero en el backoffice con la sesión del dispositivo.
 * @param {string} backofficeUrl
 * @param {string} token
 * @param {string|null|undefined} layout
 */
export function panelTargetUrl(backofficeUrl, token, layout) {
  const base = String(backofficeUrl ?? '').replace(/\/$/, '');
  const route = resolvePanelLayout(layout) === 'clasico' ? '/panel' : '/panel/interactivo';
  return `${base}/#${route}?session=${encodeURIComponent(token)}`;
}
